import { Reveal, Overline } from "./Reveal";
import { ArrowUpRight } from "lucide-react";

const REEL_URL = "https://www.instagram.com/reel/DeEM3iWRYRY/";

export const VideoTour = () => (
  <section id="tour" data-testid="tour-section" className="py-24 md:py-40">
    <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
      <Reveal>
        <Overline>Take a look inside</Overline>
        <h2 className="font-serif font-light tracking-tight leading-[0.95] text-textMain text-4xl md:text-5xl lg:text-6xl mt-6">
          See it for yourself
        </h2>
        <p className="font-sans text-textMuted leading-relaxed mt-6 max-w-xl mx-auto">
          A little tour of the cellar retreat — the spaces, the thoughtful details and the atmosphere, straight from our Instagram.
        </p>
      </Reveal>

      <Reveal delay={0.12} className="mt-12 flex justify-center">
        <div className="relative w-full max-w-[380px] rounded-xl overflow-hidden border border-line/60 bg-surface shadow-[0_40px_100px_-30px_rgba(0,0,0,0.75)]">
          <iframe
            data-testid="tour-video"
            src="https://www.instagram.com/reel/DeEM3iWRYRY/embed/"
            title="The Old Pub Cellar — video tour"
            className="w-full"
            style={{ height: 680, border: 0 }}
            loading="lazy"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            allowFullScreen
            scrolling="no"
          />
        </div>
      </Reveal>

      <Reveal delay={0.2}>
        <a
          href={REEL_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="tour-instagram-link"
          className="group inline-flex items-center gap-2 mt-8 font-mono text-[11px] uppercase tracking-[0.2em] text-textMuted hover:text-primary transition-colors"
        >
          Watch on Instagram
          <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </Reveal>
    </div>
  </section>
);
